import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "cmd01010-input-form q-gutter-y-md" }
const _hoisted_4 = { class: "row items-center q-gutter-x-md" }
const _hoisted_5 = { class: "col-2.5" }
const _hoisted_6 = { class: "row q-gutter-x-xs" }
const _hoisted_7 = { class: "row items-center justify-end" }
const _hoisted_8 = { class: "row items-center justify-end" }
const _hoisted_9 = { class: "col-2.5" }
const _hoisted_10 = { class: "row q-gutter-x-xs" }
const _hoisted_11 = { class: "row items-center justify-end" }
const _hoisted_12 = { class: "row items-center justify-end" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col" }
const _hoisted_19 = { class: "q-gutter-sm" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col q-gutter-x-xs flex justify-end" }

import { reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import Loading from 'quasar/src/plugins/Loading.js';;
import DetailResultStatusCode from '../../common/code/DetailResultStatusCode';
import axios from '../../common/axios-common';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import AlertDialog from '../../components/dialogs/AlertDialog.vue';
import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';
import FormFooterBanner from '../../components/banner/FormFooterBanner.vue';
import MessageChip from '../../components/chip/MessageChip.vue';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import { isEmpty } from '../../common/utils/validateUtils';
import messages from '../../messages/message.json';

interface Props {
  mode: string;
  newsId?: string;
}

const DIALOG_LEVEL = 'information';
// ダイアログのtitle

export default /*@__PURE__*/_defineComponent({
  __name: 'CMD01010',
  props: {
    mode: {},
    newsId: {}
  },
  setup(__props: any) {

const router = useRouter();
const now = new Date();
// お知らせ一覧画面からの遷移時に取得した値(mode, newsId)
const props = __props;
// お知らせ一覧画面で取得したお知らせID
const news_id = ref(props.newsId ? props.newsId : '');
// ダイアログのdisplayFlg(表示判断)
const dialogDisplayFlg = ref(false);
// ダイアログのlevel(informationで固定)
const dialogTitle = ref('');
// ダイアログのtext(配列にすることでXSSの対策を行う)
const dialogText = ref(['']);
// ダイアログのconfirmation(trueならキャンセルボタンを表示しない)
const dialogConfFlg = ref(false);
// 日付入力チェックのための公開開始日時
const publish_datetime = ref<Date>();
// 日付入力チェックのための公開終了日時
const publication_period = ref<Date>();
// エラーメッセージ表示フラグ
const isMessageChip = ref(false);
// エラーメッセージ
const errMessage = ref('');

const modeType = {
  // 登録
  MODE_REGISTER: '0',
  // 編集
  MODE_EDIT: '1',
};

/**
 * エラーチップを初期化
 */
const resetError = async () => {
  errMessage.value = '';
  isMessageChip.value = false;
};

/**
 * システム日付を取得
 */
const getDate = () => {
  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  const date = now.getDate();

  const mo = ref('');
  if (month < 10) {
    mo.value = `0${month.toString()}`;
  } else {
    mo.value = `${month.toString()}`;
  }

  const da = ref('');
  if (date < 10) {
    da.value = `0${date.toString()}`;
  } else {
    da.value = `${date.toString()}`;
  }

  return `${year}/${mo.value}/${da.value}`;
};

/**
 * システム時刻を取得
 */
const getTime = () => {
  const hour = now.getHours();
  const minute = now.getMinutes();

  const ho = ref('');
  if (hour < 10) {
    ho.value = `0${hour.toString()}`;
  } else {
    ho.value = `${hour.toString()}`;
  }

  const mi = ref('');
  if (minute < 10) {
    mi.value = `0${minute.toString()}`;
  } else {
    mi.value = `${minute.toString()}`;
  }

  return `${ho.value}:${mi.value}`;
};

// リセット用データ
const resetData = reactive({
  // publish_datetimeの日付部分
  start_date: getDate(),
  // publish_datetimeの時刻部分
  start_time: getTime(),
  // publication_periodの日付部分
  end_date: '',
  // publication_periodの時刻部分
  end_time: '',
  news_title: '',
  news_body: '',
  browseable_from_login_page: true,
  browseable_from_top_page: true,
});

// 入力データ
const inputData = ref({ ...resetData });

/**
 * エラー初期化
 */
const resetErrors = () => {
  errMessage.value = '';
  isMessageChip.value = false;
};

/**
 * ダイアログの中身を設定
 */
const submit = () => {
  resetErrors();
  publish_datetime.value = new Date(`${inputData.value.start_date} ${inputData.value.start_time}`);
  publication_period.value = new Date(`${inputData.value.end_date} ${inputData.value.end_time}`);

  if (publish_datetime.value >= publication_period.value) {
    errMessage.value = messages.ja.message.MSG_50071E;
    isMessageChip.value = true;
  } else if (props.mode === modeType.MODE_REGISTER) {
    dialogTitle.value = '登録確認';
    dialogText.value = ['入力された内容で登録します。', 'よろしいですか？'];
    dialogDisplayFlg.value = true;
  } else {
    dialogTitle.value = '更新確認';
    dialogText.value = ['入力された内容で更新します。', 'よろしいですか？'];
    dialogDisplayFlg.value = true;
  }
};

/**
 * クリア、リセット
 */
const reset = () => {
  inputData.value = { ...resetData };
  resetErrors();
  if (props.mode === modeType.MODE_REGISTER) {
    // クリアをかけたら公開開始日時を空欄にする
    inputData.value.start_date = '';
    inputData.value.start_time = '';
    // クリアをかけたらチェックボックスをチェックoffにする
    inputData.value.browseable_from_login_page = false;
    inputData.value.browseable_from_top_page = false;
  }
};

/**
 * お知らせ情報取得処理(更新画面の初期表示用)
 */
const getNews = async () => {
  resetErrors();
  // Loading Start
  Loading.show();
  const formData = new FormData();
  formData.append('news_id', news_id.value);

  // お知らせ情報を取得するController呼び出し
  await axios
    .post('/cmd010102/getNews', formData)
    .then((res) => {
      const { common, newsData } = res.data;

      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          Object.assign(resetData, newsData);
          inputData.value = newsData;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他のエラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * お知らせ登録処理
 */
const registerNews = async () => {
  resetErrors();
  // Loading Start
  Loading.show();

  const formData = new FormData();
  formData.append('start_date', inputData.value.start_date);
  formData.append('start_time', inputData.value.start_time);
  formData.append('end_date', inputData.value.end_date);
  formData.append('end_time', inputData.value.end_time);
  formData.append('news_title', inputData.value.news_title);
  formData.append('news_body', inputData.value.news_body);
  formData.append(
    'browseable_from_login_page',
    inputData.value.browseable_from_login_page.toString()
  );
  formData.append('browseable_from_top_page', inputData.value.browseable_from_top_page.toString());

  // お知らせ登録を行うController呼び出し
  await axios
    .post('/cmd010101/register', formData)
    .then((res) => {
      const { common } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // 登録確認ダイアログのtitleを設定
          dialogTitle.value = '登録完了';
          // 登録確認ダイアログのtextを生成
          dialogText.value = [`${inputData.value.news_title} の登録が完了しました。`];
          // ダイアログのボタン数判断をtrue(1つ)に
          dialogConfFlg.value = true;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            case DetailResultStatusCode.INSERT_ERROR:
              errMessage.value = common.message;
              isMessageChip.value = true;
              // ダイアログ表示判断をfalse(非表示)に変更
              dialogDisplayFlg.value = false;
              break;

            // パラメータエラーの場合
            case DetailResultStatusCode.PARAMETER_ERROR:
              router.push({ name: 'error' });
              break;
            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * お知らせ変更処理
 */
const editNews = async () => {
  resetErrors();
  // Loading Start
  Loading.show();

  const formData = new FormData();
  formData.append('news_id', news_id.value);
  formData.append('start_date', inputData.value.start_date);
  formData.append('start_time', inputData.value.start_time);
  formData.append('end_date', inputData.value.end_date);
  formData.append('end_time', inputData.value.end_time);
  formData.append('news_title', inputData.value.news_title);
  formData.append('news_body', inputData.value.news_body);
  formData.append(
    'browseable_from_login_page',
    inputData.value.browseable_from_login_page.toString()
  );
  formData.append('browseable_from_top_page', inputData.value.browseable_from_top_page.toString());

  // お知らせ変更を行うController呼び出し
  await axios
    .post('/cmd010102/edit', formData)
    .then((res) => {
      const { common } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // 変更確認ダイアログのtitleを設定
          dialogTitle.value = '更新完了';
          // 変更確認ダイアログのtextを生成
          dialogText.value = [`${inputData.value.news_title} の更新が完了しました。`];
          // ダイアログのボタン数判断をtrue(1つ)に
          dialogConfFlg.value = true;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            case DetailResultStatusCode.UPDATE_ERROR:
              errMessage.value = common.message;
              isMessageChip.value = true;
              // ダイアログ表示判断をfalse(非表示)に変更
              dialogDisplayFlg.value = false;
              break;

            // パラメータエラーの場合
            case DetailResultStatusCode.PARAMETER_ERROR:
              router.push({ name: 'error' });
              break;
            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

// propsが存在しない場合
if (!props.mode) {
  // 前画面に遷移
  router.replace({ name: 'news' });
} else if (props.mode === modeType.MODE_EDIT) {
  getNews();
}

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_time = _resolveComponent("q-time")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_form = _resolveComponent("q-form")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PageHeaderBanner, null, {
      title: _withCtx(() => [
        (_ctx.mode === modeType.MODE_REGISTER)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, "お知らせ新規登録"))
          : _createCommentVNode("", true),
        (_ctx.mode === modeType.MODE_EDIT)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, "お知らせ情報変更"))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(MessageChip, {
      display: isMessageChip.value,
      level: "E",
      message: errMessage.value
    }, null, 8, ["display", "message"]),
    _createVNode(_component_q_form, {
      autofocus: "",
      greedy: "",
      onSubmit: _withModifiers(submit, ["prevent"]),
      onReset: reset,
      onValidationError: resetError
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[17] || (_cache[17] = _createElementVNode("label", { class: "requier" }, "公開開始日時", -1)),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_q_input, {
                  modelValue: inputData.value.start_date,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputData.value.start_date) = $event)),
                  outlined: "",
                  dense: "",
                  class: "date q-pb-none",
                  readonly: "",
                  style: {"background":"var(--q-white)","width":"164px"},
                  clearable: "",
                  rules: [(val) => _unref(isEmpty)(val) || _ctx.$t('validation.required')],
                  "lazy-rules": ""
                }, {
                  append: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "event",
                      class: "cursor-pointer"
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_q_popup_proxy, {
                      cover: "",
                      "transition-show": "scale",
                      "transition-hide": "scale"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_date, {
                          modelValue: inputData.value.start_date,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputData.value.start_date) = $event)),
                          minimal: "",
                          mask: "YYYY/MM/DD"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_7, [
                              _withDirectives(_createVNode(_component_q_btn, {
                                label: "OK",
                                color: "primary",
                                flat: ""
                              }, null, 512), [
                                [_directive_close_popup]
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "rules"]),
                _createVNode(_component_q_input, {
                  modelValue: inputData.value.start_time,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((inputData.value.start_time) = $event)),
                  outlined: "",
                  dense: "",
                  class: "date q-pb-none",
                  readonly: "",
                  style: {"background":"var(--q-white)","width":"120px"},
                  clearable: "",
                  rules: [(val) => _unref(isEmpty)(val) || _ctx.$t('validation.required')],
                  "lazy-rules": ""
                }, {
                  append: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "access_time",
                      class: "cursor-pointer"
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_q_popup_proxy, {
                      cover: "",
                      "transition-show": "scale",
                      "transition-hide": "scale"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_time, {
                          modelValue: inputData.value.start_time,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((inputData.value.start_time) = $event)),
                          mask: "HH:mm",
                          format24h: false
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_8, [
                              _withDirectives(_createVNode(_component_q_btn, {
                                label: "OK",
                                color: "primary",
                                flat: ""
                              }, null, 512), [
                                [_directive_close_popup]
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "rules"])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[18] || (_cache[18] = _createElementVNode("label", { class: "requier" }, "公開終了日時", -1)),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_q_input, {
                  modelValue: inputData.value.end_date,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((inputData.value.end_date) = $event)),
                  outlined: "",
                  dense: "",
                  class: "date q-pb-none",
                  readonly: "",
                  style: {"background":"var(--q-white)","width":"164px"},
                  clearable: "",
                  rules: [(val) => _unref(isEmpty)(val) || _ctx.$t('validation.required')],
                  "lazy-rules": ""
                }, {
                  append: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "event",
                      class: "cursor-pointer"
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_q_popup_proxy, {
                      cover: "",
                      "transition-show": "scale",
                      "transition-hide": "scale"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_date, {
                          modelValue: inputData.value.end_date,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((inputData.value.end_date) = $event)),
                          minimal: "",
                          mask: "YYYY/MM/DD"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_11, [
                              _withDirectives(_createVNode(_component_q_btn, {
                                label: "OK",
                                color: "primary",
                                flat: ""
                              }, null, 512), [
                                [_directive_close_popup]
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "rules"]),
                _createVNode(_component_q_input, {
                  modelValue: inputData.value.end_time,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((inputData.value.end_time) = $event)),
                  outlined: "",
                  dense: "",
                  class: "date q-pb-none",
                  readonly: "",
                  style: {"background":"var(--q-white)","width":"120px"},
                  clearable: "",
                  rules: [(val) => _unref(isEmpty)(val) || _ctx.$t('validation.required')],
                  "lazy-rules": ""
                }, {
                  append: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "access_time",
                      class: "cursor-pointer"
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_q_popup_proxy, {
                      cover: "",
                      "transition-show": "scale",
                      "transition-hide": "scale"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_time, {
                          modelValue: inputData.value.end_time,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((inputData.value.end_time) = $event)),
                          mask: "HH:mm",
                          format24h: false
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_12, [
                              _withDirectives(_createVNode(_component_q_btn, {
                                label: "OK",
                                color: "primary",
                                flat: ""
                              }, null, 512), [
                                [_directive_close_popup]
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "rules"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _cache[19] || (_cache[19] = _createElementVNode("label", { class: "requier" }, "件名", -1)),
              _createVNode(_component_q_input, {
                modelValue: inputData.value.news_title,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((inputData.value.news_title) = $event)),
                outlined: "",
                dense: "",
                maxlength: 100,
                class: "input-area",
                counter: "",
                rules: [(val) => _unref(isEmpty)(val) || _ctx.$t('validation.required')],
                "lazy-rules": "",
                onKeydown: _cache[9] || (_cache[9] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
              }, null, 8, ["modelValue", "rules"])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _cache[20] || (_cache[20] = _createElementVNode("label", { class: "requier" }, "本文", -1)),
              _createVNode(_component_q_input, {
                modelValue: inputData.value.news_body,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((inputData.value.news_body) = $event)),
                outlined: "",
                dense: "",
                type: "textarea",
                rows: "7",
                maxlength: 1000,
                counter: "",
                rules: [(val) => _unref(isEmpty)(val) || _ctx.$t('validation.required')],
                "lazy-rules": ""
              }, null, 8, ["modelValue", "rules"])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _cache[21] || (_cache[21] = _createElementVNode("label", null, "表示対象", -1)),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_q_checkbox, {
                  modelValue: inputData.value.browseable_from_login_page,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((inputData.value.browseable_from_login_page) = $event)),
                  label: "ログインページ",
                  color: "primary"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_q_checkbox, {
                  modelValue: inputData.value.browseable_from_top_page,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((inputData.value.browseable_from_top_page) = $event)),
                  label: "トップページ",
                  color: "primary"
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createVNode(FormFooterBanner, { style: {"position":"inherit"} }, {
            "button-area": _withCtx(() => [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_q_btn, {
                  color: "grey-7",
                  outline: "",
                  label: "戻る",
                  style: {"min-width":"120px","background":"var(--q-white) !important"},
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_unref(router).replace({ name: 'news' })))
                }),
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_q_btn, {
                    type: "submit",
                    color: "primary",
                    style: {"width":"150px"},
                    label: _ctx.mode === modeType.MODE_REGISTER ? '登録' : '変更'
                  }, null, 8, ["label"]),
                  _createVNode(_component_q_btn, {
                    type: "reset",
                    outline: "",
                    style: {"width":"150px","background":"var(--q-white) !important","color":"var(--q-delete)"},
                    icon: _ctx.mode === modeType.MODE_REGISTER ? 'mdi-eraser' : 'cached',
                    label: _ctx.mode === modeType.MODE_REGISTER ? 'クリア' : 'リセット'
                  }, null, 8, ["icon", "label"])
                ])
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(AlertDialog, {
      display: dialogDisplayFlg.value,
      level: DIALOG_LEVEL,
      confirmation: dialogConfFlg.value,
      title: dialogTitle.value,
      text: dialogText.value,
      onComplete: _cache[14] || (_cache[14] = ($event: any) => (_unref(router).replace({ name: 'news' }))),
      onConfirm: _cache[15] || (_cache[15] = ($event: any) => (_ctx.mode === modeType.MODE_REGISTER ? registerNews() : editNews())),
      onClose: _cache[16] || (_cache[16] = ($event: any) => (dialogDisplayFlg.value = false))
    }, null, 8, ["display", "confirmation", "title", "text"])
  ]))
}
}

})